import React, {Component} from 'react';
import { connect } from 'react-redux';
import { getNotificationCategories, updateProfileNotificationSettings } from '../../../SHARED/actions/editprofile.actions';

class EditNotification extends Component {

    constructor(props) {
        super(props);
        this.state = {
            notification_account: [],
            notification_email: []
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        this.props.getNotificationCategories();
    }

     componentWillReceiveProps(nextProps){
         if(nextProps.notification){
            this.setState({notification_account: nextProps.notification.notificationAccount, notification_email: nextProps.notification.notificationEmail})
         }
     }

    getNotificationCategories = () => {
        if (this.props.notificationCategories && this.props.notification){
            return this.props.notificationCategories.map((category) => {
                return <div className="notif-item" key={category.id}>
                            <span>{category.name}</span>
                            { this.props.notification.notificationEmail.includes(category.id)  ?
                                <input className="notif-check" type="checkbox" name="email" value={category.id} onChange={this.handleChange} defaultChecked /> :
                                <input className="notif-check" type="checkbox" name="email" value={category.id} onChange={this.handleChange} />
                            }
                            { this.props.notification.notificationAccount.includes(category.id)  ?
                                <input className="notif-check" type="checkbox" name="account" value={category.id} onChange={this.handleChange} defaultChecked /> :
                                <input className="notif-check" type="checkbox" name="account" value={category.id} onChange={this.handleChange} />
                            }
                        </div>
            })
        }
        else {
            if (this.props.notificationCategories){
                return this.props.notificationCategories.map((category) => {
                    return <div className="notif-item" key={category.id}>
                        <span>{category.name}</span>
                            <input className="notif-check" type="checkbox" name="email" value={category.id} onChange={this.handleChange} />
                            <input className="notif-check" type="checkbox" name="account" value={category.id} onChange={this.handleChange} />         
                    </div>
                })
            }
        }
    }

    handleChange = event => {
        const target = event.target;
        if (target.checked)
        {
            target.name === "email" ? this.state.notification_email.push(parseInt(target.value, 10)) : this.state.notification_account.push(parseInt(target.value, 10));
        }
        else {
            if (target.name === "email"){
               let arr = this.state.notification_email.filter(item => { return item !== parseInt(target.value, 10) })
               this.setState({notification_email: arr})
            }
            else {
                let arr = this.state.notification_account.filter(item => {return item !== parseInt(target.value, 10)})
                this.setState({notification_account: arr})
            }
        }
    }

    save = () => {
        this.props.updateProfileNotificationSettings(this.state);
    }

    render() {
        return(
            <div className="notifications">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="col-lg-7">
                            <div className="edit-profile-item-header clearfix">
                                <span className="profile-favorite db float-left">Doresc să primesc notificări pentru următoarele</span>
                                <span className="notif-where db float-right">Pe email</span>
                                <span className="notif-where db float-right">În contul meu</span>             
                            </div>
                            {this.getNotificationCategories()}
                        </div>
                    </div>
                    <div className="col-lg-12 save-notif">
                        <button type="submit" className="save-button" onClick={this.save}>Salvează</button>
                    </div>
                </div>  
            </div>
        )
    }
}

const mapStateToProps = state => ({
    notificationCategories: state.editProfile.notificationCategories.terms,
})

export default connect(mapStateToProps, {getNotificationCategories, updateProfileNotificationSettings})(EditNotification);


// WEBPACK FOOTER //
// ./src/FO/components/editnotification/editnotification.component.js